import React from 'react';
import { Loader, Users, TrendingUp, Clock } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { useIsMobile } from '../../hooks/use-mobile';
import SectionHeader from './SectionHeader';

const TopicList = ({ trendingTopics, isLoading }) => {
  const isMobile = useIsMobile();

  return (
    <div className="bg-white rounded-lg p-4">
      <SectionHeader
        icon={isLoading ? <Loader size={20} className="text-[#8B5CF6] animate-spin"/> : <TrendingUp size={20} className="text-[#8B5CF6]" />}
        title="Trending AI Conversations"
      />
      
      {isMobile ? (
        // Mobile view - Compact stacked cards
        <div className="grid grid-cols-1 gap-2">
          {trendingTopics?.map((topic, index) => (
            <Card
              key={index}
              className={`border-l-4 hover:shadow-md transition-shadow cursor-pointer border-l-purple-500`}
            >
              <CardContent className="p-2">
                <div className="flex justify-between items-start mb-1">
                  <h4 className="font-medium text-gray-900 text-xs">
                    🟪 {topic.name}
                  </h4>
                </div>
                <div className="flex items-center gap-2 mt-1 text-xs">
                  <div className="flex items-center text-gray-500">
                    <Users className="w-3 h-3 mr-0.5" />
                    <span>{topic.occurrences}</span>
                  </div>
                  <div className="flex items-center text-gray-500">
                    <Clock className="w-3 h-3 mr-0.5" />
                    <span>{topic.lastOccurence}</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      ) : (
        // Desktop view - More efficient columns
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {trendingTopics?.map((topic, index) => (
            <Card
              key={index}
              className={`border-l-4 hover:shadow-md transition-shadow cursor-pointer border-l-purple-500`}
            >
              <CardContent className="p-3">
                <div className="flex justify-between items-start mb-1">
                  <h4 className="font-medium text-gray-900 text-sm">
                    🟪 {topic.name}
                  </h4>
                </div>
                <div className="flex flex-wrap items-center gap-2 mt-1.5 text-xs">
                  <div className="flex items-center text-gray-500">
                    <Users className="w-3 h-3 mr-0.5" />
                    <span>{topic.occurrences}</span>
                  </div>
                  <div className="flex items-center text-gray-500">
                    <Clock className="w-3 h-3 mr-0.5" />
                    <span>{topic.lastOccurence}</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default TopicList;
